import { flatMap, map } from 'lodash';
import { RoleType } from '../enums/role-type';
import { Agency } from '../interfaces/agency';
import { Location } from './location';
import { Permission } from './permission';
import { UserRole, IUserRoleData } from './user-role';
import { ProviderType } from '../enums/provider-type';

export interface IUserData {
  displayName?: string;
  name?: string;
  uid?: string;
  sid?: string;
  pid?: number;
  lastName?: string;
  firstName?: string;
  given_name?: string;
  family_name?: string;
  userGuid?: string;
  email?: string;
  EmailAddress?: string;
  preferred_username?: string;
  sub?: string;
  doeEmployeeId?: string;
  currentAgency?: Agency;
  userRoles?: IUserRoleData[];
  personSk?: string;
  selectedRole?: UserRole;
  selectedLocation?: Location;
  isMDE?: boolean;
  isMDESupervisor?: boolean;
  isSupervisor?: boolean;
  agencySk?: string[];
  isGlobalUser?: boolean;
  isViewOnly?: boolean;
  userType?: string;
  roleType?: RoleType;
  loginID?: string;
  providerSk?: string;
  isTransmittalCoordinator?: boolean;
  csLocation?: string;
  providerType?: ProviderType;
  actor?: string;
}

export class User {
  displayName: string;
  name: string;
  username: string;
  uid: string;
  sid: string;
  pid: number;
  lastName: string;
  firstName: string;
  userGuid: string;
  email: string;
  preferred_username: string;
  sub: string;
  doeEmployeeId: string;
  currentAgency?: Agency;
  userRoles: UserRole[];
  personSk: string;
  permissions: Permission[];
  selectedRole: UserRole;
  selectedLocation: Location;
  locationsForSelectedRole: Location[];
  isMDE: boolean;
  isMDESupervisor: boolean;
  isSupervisor: boolean;
  agencySk: string[];
  isGlobalUser: boolean;
  isViewOnly: boolean;
  userType: string;
  roleType: RoleType;
  loginID?: string;
  providerSk: string;
  isTransmittalCoordinator: boolean;
  csLocation: string;
  providerType: ProviderType;
  actor?: string;
  constructor(data: Partial<IUserData>) {
    this.displayName = data?.displayName;
    this.name = data?.name;
    this.username = data?.name;
    this.uid = data?.uid;
    this.sid = data?.sid;
    this.pid = data?.pid;
    this.userGuid = data?.userGuid;
    this.preferred_username = data?.preferred_username;
    this.firstName = data?.firstName || data.given_name;
    this.lastName = data?.lastName || data.family_name;
    this.sub = data?.sub;
    this.email = data?.EmailAddress || data?.email;
    this.personSk = data?.personSk;
    this.doeEmployeeId = data?.doeEmployeeId;
    this.currentAgency = data?.currentAgency;
    this.selectedLocation = data?.selectedLocation;
    this.selectedRole = data?.selectedRole;
    this.userRoles = data?.userRoles
      ? map(data.userRoles, (r: IUserRoleData) => new UserRole(r))
      : undefined;
    this.permissions = this?.userRoles
      ? flatMap(this.userRoles, (r: UserRole) => r.userPermissions)
      : undefined;
    this.isMDE = data?.isMDE;
    this.isMDESupervisor = data?.isMDESupervisor;
    this.isSupervisor = data?.isSupervisor;
    this.agencySk = data?.agencySk;
    this.isGlobalUser = data?.isGlobalUser;
    this.isViewOnly = data?.isViewOnly;
    this.userType = data?.userType;
    this.roleType = data?.roleType;
    this.providerSk = data?.providerSk;
    this.isTransmittalCoordinator = data?.isTransmittalCoordinator;
    this.loginID = data?.loginID;
    this.csLocation = data?.csLocation;
    this.providerType = data?.providerType;
    this.actor = data?.actor;
  }
}
